import { DocusealForm } from "@docuseal/react"
import React, { useContext, useState } from "react"
import { useMutation } from "react-query"

import AlertBanner from "src/components/AlertBanner"

import { updateDocusealSubmission } from "src/api/Contracts"

import { useToast } from "src/hooks/use_toast"

import { logger } from "src/utils/datadog"

import { SignContractWizardContext } from "../SignContractWizardContext"

const DocusealSigningForm = () => {
  const {
    docusealSubmitterSlug,
    dispatch,
    dockwaLogo,
    quote,
    convenienceFeeCopy,
    state,
  } = useContext(SignContractWizardContext)
  const [key, setKey] = useState(Date.now())
  const showToast = useToast()

  const { mutate: updateSubmission } = useMutation(
    (data) => updateDocusealSubmission({ data, quoteId: quote.encodedId }),
    {
      onSuccess: () => {
        dispatch({
          type: "DOCUSEAL_FORM_COMPLETED",
        })
      },
      onError: () => {
        showToast(
          "Error submitting contract. If the issue persists, contact mayday@dockwa.com",
          { type: "error" }
        )
      },
    }
  )

  const handleComplete = (data) => {
    const { status } = data

    if (status === "completed") {
      logger.info("Docuseal submission update initiated", {
        quoteId: quote.encodedId,
        submissionStatus: status,
        contractSigningFormState: state,
      })

      updateSubmission({
        contract_quote_id: quote.encodedId,
        status,
      })
      setKey(Date.now())
    }
  }

  const handleOnLoad = (data) => {
    if (data.completed_submitter && state.docusealFormCompleted === false) {
      // If we load the form, and it shows as already completed, but our local state is not updated, we need to sync it
      // This would mean that somehow the server state and local storage state do not match the Docuseal state (which is the source of truth)
      logger.info(
        "Docuseal form state mismatch detected - form already completed in Docuseal - syncing state",
        {
          quoteId: quote.encodedId,
          docusealFormOnLoadData: data,
          contractSigningFormState: state,
        }
      )
      dispatch({
        type: "DOCUSEAL_FORM_COMPLETED",
      })
    }
  }

  const renderConvenienceFeeNotice = () => {
    if (convenienceFeeCopy.steps?.signAndComplete) {
      return (
        <div className="my-5">
          <AlertBanner type="info">
            {convenienceFeeCopy.steps.signAndComplete}
          </AlertBanner>
        </div>
      )
    }
  }

  return (
    <>
      <DocusealForm
        src={`https://docuseal.co/s/${docusealSubmitterSlug}`}
        key={key}
        logo={dockwaLogo}
        onComplete={handleComplete}
        onLoad={handleOnLoad}
        sendCopyEmail={false}
        withTitle={false}
        withSendCopyButton={false}
        allowToResubmit={false}
        expand={false}
        withDownloadButton={false}
        goToLast={false}
        i18n={{
          form_has_been_submitted_already: " ",
          "form_has_been_archived.":
            "There have been changes made to this agreement, please refresh the page and try signing again.",
        }}
      />
      {renderConvenienceFeeNotice()}
    </>
  )
}

export default DocusealSigningForm
